import React from 'react'
import DividerSection from '@/components/DividerSection'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

import s from './styles.module.scss'

const CardSelectedService = ({ name, price, description, duration, id, isExtra, moneySign, handleDeleteService }) => {
  const serviceName = name?.toUpperCase() || 'SERVICIO'
  const serviceDescription = description || 'No especificado'
  const serviceDuration = duration ?? 'No especificada'
  return (
    <div className={s.cardContainer}>
      <div className={s.serviceHeader}>
        <span className={s.serviceName}>{serviceName}</span>

        {isExtra && (
          <button type="button" className={s.deleteItem} onClick={() => handleDeleteService(id)}>
            Eliminar
          </button>
        )}
      </div>

      <div className={s.serviceInfo}>
        <div>
          <span className={s.serviceLabel}>Monto:</span> {moneySign} {price}
        </div>

        <div>
          <span className={s.serviceLabel}>Descripción:</span> {serviceDescription}
        </div>
      </div>

      <DividerSection />

      <div className={s.duration}>
        <AccessTimeIcon fontSize="small" />
        Duración: {serviceDuration} minutos
      </div>
    </div>
  )
}

export default CardSelectedService
